import { useApiClient } from '@m43/core';
import { EventPanelResource, EventPanelSelfInitiate, PhoneCallDto } from '@mark43/cad-api';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';

export function useEventPanelViewQuery(props: {
    queryKey?: string | number;
    eventId?: number;
    phoneCallDto?: PhoneCallDto;
    selfInitiate?: EventPanelSelfInitiate;
    queryOptions?: {
        cacheTime: UseQueryOptions['cacheTime'];
    };
}) {
    const apiClient = useApiClient();
    const { queryKey, phoneCallDto, selfInitiate, eventId, queryOptions } = props;
    return useQuery({
        queryKey: ['event-panel-view', queryKey ?? eventId],
        queryFn() {
            return apiClient
                .request<EventPanelResource.GetEventPanelView>({
                    method: 'POST',
                    url: 'event_panel/',
                    data: {
                        metadata: true,
                        form: true,
                        configuration: false,
                        options: false,
                        eventId,
                        eventPanelPrefill: {
                            eventOrigin911: phoneCallDto ? true : false,
                            phoneCallDto,
                            eventPanelSelfInitiate: selfInitiate ?? undefined,
                        },
                    },
                })
                .then((data) => {
                    return data.data.data;
                });
        },
        enabled: false,
        ...queryOptions,
    });
}
